<template>
  <div class="min-body">
    <!-- banner -->
    <banner :banner-list="bannerList"></banner>
    <!-- 产品功能 -->
    <ProductFunctions :CoreFeaturesList="CoreFeaturesList"></ProductFunctions>

    <!-- 客户案例 -->
    <SectionTitle :title="$t('sectionTitle.customerCase')" subtitle="" style="margin:100px 0 30px 0;" />
    <CustomerCase :caseList="caseList"></CustomerCase>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import SectionTitle from "@/components/SectionTitle/index.vue";
import CustomerCase from "@/views/Home/components/CustomerCase/index.vue";
import banner from "@/views/Home/components/Banner/banner.vue";
import ProductFunctions from "./components/ProductFunctions.vue";
// 引入 JSON 配置
import Products from "@/config/Products.js"

export default {
  name: "index",
  components:{
    banner,
    CustomerCase,
    SectionTitle,
    Footer,
    ProductFunctions
  },
  data() {
    return {
      bannerList: [],
      CoreFeaturesList: [],
      caseList: []
    }
  },
  watch: {
    // 监听整个路由对象变化
    $route: {
      handler() {
        // 获取到当前核心产品的数据
        this.handleProductsData()
        window.scrollTo(0, 0);
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    // 获取到当前核心产品的数据
    this.handleProductsData()
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleProductsData() {
      var data = Products.find(item => item.id == this.$route.query.id);
      if (data) {
        this.bannerList = data.bannerList;
        this.CoreFeaturesList = data.CoreFeaturesList;
        this.caseList = data.CustomerCaseList;
      }
      console.log(data);
    }
  }
}
</script>

<style scoped>
.min-body {
  width: 100%;
}
</style>